import { useTranslation } from 'react-i18next'
import { VapiVoiceTestConsole } from '../components/vapi-voice-test/VapiVoiceTestConsole'

export function VapiVoiceTestPage() {
  const { t } = useTranslation('calls')
  return (
    <div className="flex h-full flex-col gap-4">
      <div>
        <h1 className="text-2xl font-bold">{t('voiceTest.title')}</h1>
        <p className="mt-1 text-sm text-text-secondary">{t('voiceTest.subtitle')}</p>
      </div>
      <div className="min-h-0 flex-1">
        <VapiVoiceTestConsole />
      </div>
    </div>
  )
}
